import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 4V2H4v6h14V6h1v4H9v12h4V12h8V4h-3z"
}), 'FormatPaintSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatPaintSharp.js
// module id = 3877
// module chunks = 2